import { useDomainConfig } from './hooks/useDomainConfig';
import { StoreProvider, useStore } from './lib/store';
import { Login } from './components/Login';
import { Inbox } from './components/Inbox';
import { Admin } from './components/Admin';
import { Toasts } from './components/Toasts';
import { useEffect } from 'preact/hooks';
import type { Session } from './lib/types';

function MainApp({ domain }: { domain: string }) {
  const { session, setSession } = useStore();

  useEffect(() => {
    document.title = domain + ' — Nostr-verified email';
  }, [domain]);

  return (
    <>
      {session ? (
        <Inbox domain={domain} />
      ) : (
        <Login domain={domain} onAuthenticated={(s: Session) => setSession(s)} />
      )}
      <Toasts />
    </>
  );
}

export function App() {
  const config = useDomainConfig();
  const isAdmin =
    typeof window !== 'undefined' &&
    window.location.pathname.includes('admin');

  useEffect(() => {
    if (config) {
      document.title = isAdmin
        ? config.domain + ' Admin'
        : config.domain + ' — Nostr-verified email';
    }
  }, [config, isAdmin]);

  if (!config) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: 'var(--muted)' }}>
        Loading…
      </div>
    );
  }

  if (isAdmin) {
    return <Admin domain={config.domain} />;
  }

  return (
    <StoreProvider>
      <MainApp domain={config.domain} />
    </StoreProvider>
  );
}
